module.exports = __webpack_public_path__ + "static/media/박상권.4f098664.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/박상권.png
// module id = 105
// module chunks = 0